export const userReportExportHeaders = [
  {
    label: 'Name',
    key: 'name',
  },
  {
    label: 'Email Address',
    key: 'email',
  },
  { label: 'Designation', key: 'designation' },
  { label: 'System Role', key: 'systemRole' },
  { label: 'Date Created', key: 'createdAt' },
  { label: 'Status', key: 'status' },
  { label: 'Report Start Date', key: 'startDate' },
  { label: 'Report End Date', key: 'endDate' },
  { label: 'No. of Logins', key: 'noLogins' },
  { label: 'Average Duration', key: 'averageDuration' },
  { label: 'Last Login Duration', key: 'lastLoginDuration' },
];
